
import gaussian  from '@/assets/js/gaussian.js'
(function ($) {
  $(document).ready(function () {
    const optionvalueName = 'option-value';
    let path = location.pathname.split('/').filter(Boolean).pop();
    let optionvalueCalculator = 'option-value';

    const calculatorConstants = {
      'option-value': {
        'underlying': { //  decimal with 2 digits  (S0)
          default: 1000,
          min: 0,
          max: 100000.
        },
        'strike': {   // is an integer (X)
          default: 1000,
          min: 0,
          max: 100000
        },
        'volatility': {   // in percentage (σ) 
          default: 5,
          min: 0,
          max: 250
        },
        'interest_rate': {   // in percentage (r)
          default: 5,
          min: 0,
          max: 250
        },
        'dividend': {   // in percentage (q)
          default: 5,
          min: 0,
          max: 20
        },
        'expiration': {   // is an integer (d)
          default: 5,
          min: 0,
          max: 365
        }
      }
    };

    let underlying = calculatorConstants[path].underlying.default;
    let strike = calculatorConstants[path].strike.default;
    let volatility = calculatorConstants[path].volatility.default;
    let interest_rate = calculatorConstants[path].interest_rate.default;
    let dividend = calculatorConstants[path].dividend.default;
    let expiration = calculatorConstants[path].expiration.default;
 
    const callPrice = document.getElementById('call-price');
    const putPrice = document.getElementById('put-price');
    const callDelta = document.getElementById('call-delta');    
    const putDelta =  document.getElementById('put-delta');
    const gammaAmount =  document.getElementById('gamma-value');
    const vegaAmount =  document.getElementById('vega-value');
    const callTheta =  document.getElementById('call-theta');
    const putTheta =  document.getElementById('put-theta');
    const callRho =  document.getElementById('call-rho');
    const putRho =  document.getElementById('put-rho');

    function updateoptionValues() {
      const totalReturnValue = calculateoptionReturn();
      callPrice.innerHTML = '₹ ' + Number(totalReturnValue[0]).toFixed(4).toLocaleString('en-IN');
      putPrice.innerHTML = '₹ ' + Number(totalReturnValue[1]).toFixed(4).toLocaleString('en-IN');
      callDelta.innerHTML = Number(totalReturnValue[2]).toFixed(4).toLocaleString('en-IN');
      putDelta.innerHTML = Number(totalReturnValue[3]).toFixed(4).toLocaleString('en-IN');
      gammaAmount.innerHTML = Number(totalReturnValue[4]).toFixed(4).toLocaleString('en-IN');
      vegaAmount.innerHTML = Number(totalReturnValue[5]).toFixed(4).toLocaleString('en-IN');
      callTheta.innerHTML = Number(totalReturnValue[6]).toFixed(4).toLocaleString('en-IN');
      putTheta.innerHTML = Number(totalReturnValue[7]).toFixed(4).toLocaleString('en-IN');
      callRho.innerHTML = Number(totalReturnValue[8]).toFixed(4).toLocaleString('en-IN');
      putRho.innerHTML = Number(totalReturnValue[9]).toFixed(4).toLocaleString('en-IN');
    }

    /**
     * Rangeslider.js initialization
     */
    $('input[type="range"]').rangeslider({
      polyfill: false,

      // Default CSS classes
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",

      onInit: function () {},

      onSlide: function (position, value) {},

      onSlideEnd: function (position, value) {},
    });

    /**
     * Forces input value to stay within the range
     */
    function forceValueRanges(input, type, forceMin = false) {
      const value = Number(input.val());
      const allowedMax = calculatorConstants[path][type].max;
      const allowedMin = calculatorConstants[path][type].min;
      if (value > allowedMax) {
        input.val(allowedMax);
      }

      function forceMinValues() {
        if (value < allowedMin && value) {
          input.val(allowedMin);
        }
      }

      if (forceMin) {
        forceMinValues();
      }
    };

    
    /**
     * Input field listeners
     */
    $('input#underlying-investment-input').on('input', function (event) {
      forceValueRanges($('input#underlying-investment-input'), 'underlying');
      underlying = Number(event.target.value);
      $('input#underlying-investment-slider').val(underlying).change();
    });

    $('input#strike-rate-input').on('input', function (event) {
      forceValueRanges($('input#strike-rate-input'), 'strike', true);
      strike = Number(event.target.value);
      $('input#strike-rate-slider').val(strike).change();
    });

    $('input#volatility-input').on('input', function (event) {
      forceValueRanges($('input#volatility-input'), 'volatility', true);
      volatility = Number(event.target.value);
      $('input#volatility-input-slider').val(volatility).change();
    });

     $('input#interest-input').on('input', function (event) {
      forceValueRanges($('input#interest-input'), 'interest_rate', true);
      interest_rate = Number(event.target.value);
      $('input#interest-input-slider').val(interest_rate).change();
    });

     $('input#dividend-input').on('input', function (event) {
      forceValueRanges($('input#dividend-input'), 'dividend', true);
      dividend = Number(event.target.value);
      $('input#dividend-input-slider').val(dividend).change();
    });

    $('input#expiration-input').on('input', function (event) {
      forceValueRanges($('input#expiration-input'), 'expiration', true);
      expiration = Number(event.target.value);
      $('input#expiration-input-slider').val(expiration).change();
    });

    /**
     * Slider input listeners
     */
    $('input#underlying-investment-slider').on('input', function (event) {
      underlying = Number(event.target.value);
      if (underlying > 0) {
        $('input#underlying-investment-input').val(underlying);
      }
    });

    $('input#strike-rate-slider').on('input', function (event) {
      strike = Number(event.target.value);
      $('input#strike-rate-input').val(strike);
    });

    $('input#volatility-input-slider').on('input', function (event) {
      volatility = Number(event.target.value);
      $('input#volatility-input').val(volatility);
    });

    $('input#interest-input-slider').on('input', function (event) {
      interest_rate = Number(event.target.value);
      $('input#interest-input').val(interest_rate);
    });

    $('input#dividend-input-slider').on('input', function (event) {
      dividend = Number(event.target.value);
      $('input#dividend-input').val(dividend);
    });

    $('input#expiration-input-slider').on('input', function (event) {
      expiration = Number(event.target.value);
      $('input#expiration-input').val(expiration);
    });


    $("input[type=number]").on("keydown", function(e) {
      let invalidChars = ["-", "+", "e"];
      if (invalidChars.includes(e.key)) {
          e.preventDefault();
      }
    });

    function calculateoptionReturn() {
      const S = Number(strike); 
      const U = Number(underlying);
      const V = Number(volatility)/100;
      const I = Number(interest_rate)/100;
      const D = Number(dividend);
      const E = Number(expiration)/365;

      const d1 = (Math.log(U/S) + (I + Math.pow(V,2)/2) * E) / (V*Math.sqrt(E)),
      d2 = (Math.log(U/S) + (I - Math.pow(V,2)/2) * E) / (V*Math.sqrt(E));
      const fv_strike = (S)*Math.exp(-1*I*E);

      //For calculating CDF and PDF using gaussian library
      const distribution = gaussian(0, 1);

      //Premium Price
      const call_premium = U * distribution.cdf(d1) - fv_strike * distribution.cdf(d2),
      put_premium = fv_strike * distribution.cdf(-1*d2) - U * distribution.cdf(-1*d1);

      //Option greeks
      const call_delta = distribution.cdf(d1),
      put_delta = call_delta-1;

      const call_gamma = distribution.pdf(d1)/(U*V*Math.sqrt(E));
       if(isNaN(call_gamma)){
         call_gamma = 0;
      }
      var put_gamma = call_gamma; 

      const call_vega = U*distribution.pdf(d1)*Math.sqrt(E)/100;
      if(isNaN(call_vega)){
         call_vega = 0;
      }
      var put_vega = call_vega;

      const call_theta = (-1*U*distribution.pdf(d1)*V/(2*Math.sqrt(E)) - I*fv_strike*distribution.cdf(d2))/365,
      put_theta = (-1*U*distribution.pdf(d1)*V/(2*Math.sqrt(E)) + I*fv_strike*distribution.cdf(-1*d2))/365;

      const call_rho = fv_strike*E*distribution.cdf(d2)/100,
      put_rho = -1*fv_strike*E*distribution.cdf(-1*d2)/100;

      return [call_premium, put_premium, call_delta, put_delta, call_gamma, call_vega, call_theta,put_theta, call_rho, put_rho];

    }
  
  //  for similar Calculator Section 

      jQuery(".btn-all").click(function(){
        jQuery(".smooth-wrap").addClass("smooth-wrap2");
        jQuery(".btn-all").hide();
        jQuery(".btn-less").show();
    });

     jQuery(".btn-less").click(function(){
        jQuery(".smooth-wrap").removeClass("smooth-wrap2");
        jQuery(".btn-all").show();
        jQuery(".btn-less").hide();
      });
  

    $(document).on('input', function() {
      updateTextValues();
    });

    function updateTextValues() {
      return updateoptionValues();
    }

    function init() {
      updateTextValues();
    }
    
    init();

  });
})(jQuery);